import { compareSemver } from "./semver";

export type AppVersionStatus = "forced" | "suggested" | "ok";

// Pure, stateless decision. No React, no side effects.
//
// Defensive default: if any version string can't be parsed, return "ok".
// We never want to block the user because of malformed config.
export const computeVersionStatus = (
  currentNative: string | null | undefined,
  latest: string | null | undefined,
  minimum: string | null | undefined,
): AppVersionStatus => {
  const currentVsMinimum = compareSemver(currentNative, minimum);
  const currentVsLatest = compareSemver(currentNative, latest);
  if (currentVsMinimum === null || currentVsLatest === null) return "ok";
  if (currentVsMinimum < 0) return "forced";
  if (currentVsLatest < 0) return "suggested";
  return "ok";
};
